// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"1bd839b7","28":"f06609e0"}[chunkId] + ".chunk.js";
};